module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/modal/modal-modificar-imagen/modal-modificar-imagen.component.css
// module id = ./src/app/shared/modal/modal-modificar-imagen/modal-modificar-imagen.component.css
// module chunks = main